import { styled } from '../../../styled';

export const InputWrapper = styled.div`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing[2]};
`;
